import loadable from '@loadable/component';

const PopularFacetsLoader = loadable(() =>
  import(/* webpackChunkName: "popular-facets" */ './popular-facets-sections')
);

export default PopularFacetsLoader;
